module.exports = __webpack_public_path__ + "static/img/brees-2003-top.e5b5401.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2003-top.jpg
// module id = D1Xk
// module chunks = 1